import baseUrl from "./base"
import {postRequest, postRequestCustomHeaders, getRequest, getRequestCustomHeaders} from "./common"


const record12Api = {
    //添加展馆访问记录
    "insertHallViewRecord": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record12/insertHallViewRecord`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                login: null,
                companycode: null,
                addinfo1: null,  //展館id
                addinfo2: null,  //訪問展館的用戶id
                addinfo3: null  //訪問展館的用戶countrycode
            }
        }
    },
    //添加3DShopopee访问记录
    "insertViewNumAdditionalrecord12": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record12/insertViewNumAdditionalrecord12`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {

            }
        }
    },
    //查詢DShopopee访问记录
    "queryAdditionalrecord12": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record12/queryAdditionalrecord12`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {

            }
        }
    }


}

export default record12Api